"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ItemCard_1 = __importDefault(require("../ItemCard"));
const bridge_1 = require("@completeanatomy/bridge");
const device_1 = require("@completeanatomy/device");
const ui_1 = require("@completeanatomy/ui");
const react_router_dom_1 = require("react-router-dom");
const i18n_1 = require("@completeanatomy/i18n");
const utils_1 = require("../../utils");
const analytics_1 = require("@completeanatomy/analytics");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
const odr_1 = require("@completeanatomy/odr");
const hooks_1 = require("../../hooks");
const noop_1 = __importDefault(require("lodash/noop"));
function ModelsTab({ onResize = noop_1.default }) {
    const { models = [] } = (0, hooks_1.useTabContent)(bridge_schema_1.InfoBoxTabType.Models);
    const bridge = (0, bridge_1.useBridge)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { isMobile } = (0, device_1.usePlatform)();
    const { show } = (0, odr_1.useOfflineSnackbars)();
    const modelsWithAccess = (0, models_1.useModelsAccess)(models);
    const isOffline = (0, device_1.useIsDeviceOffline)();
    const odrModels = (0, odr_1.useOdrModels)();
    const analytics = (0, analytics_1.useAnalytics)();
    const sendAnalyticsEvent = (title) => {
        const segmentation = {
            name: title,
            toolType: bridge_schema_1.InfoBoxTabType.Models,
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        };
        analytics.log('InfoboxItemSelected', segmentation);
    };
    const getSize = (ref) => {
        if (!ref) {
            return;
        }
        const { width, height } = ref.getBoundingClientRect();
        onResize({ width, height });
    };
    const isModelNotAvailable = ({ identifier, isDetailed }) => {
        const odrModel = odrModels === null || odrModels === void 0 ? void 0 : odrModels.find(m => m.identifier === identifier);
        const isCached = odrModel === null || odrModel === void 0 ? void 0 : odrModel.isCached;
        return isDetailed && !isCached && isOffline;
    };
    const handleClick = (model) => () => {
        const { mask, type } = model;
        sendAnalyticsEvent(model.name);
        if (isModelNotAvailable(model)) {
            show(odr_1.ODRSnackbars.OfflineModelSnackbar);
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.selectModelAndRegion({
            bodyRegionMask: mask,
            modelType: type,
            isOpenedFromInfobox: true,
        });
        const arrayStateOptions = {
            mask: mask.toString(),
            type: type.toString(),
        };
        return navigate({
            pathname: '/',
            search: (0, react_router_dom_1.createSearchParams)(arrayStateOptions).toString(),
        });
    };
    const groupedModels = (0, utils_1.groupModels)(modelsWithAccess || []);
    return ((0, jsx_runtime_1.jsx)(ui_1.ScrollView, { ref: getSize, hasScroll: true, "data-e2e": 'ModelsTab_ScrollView', children: Object.entries(groupedModels)
            .sort(sortSections)
            .map(([type, group]) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(SectionName, { "$isMobile": isMobile, "data-e2e": 'ModelsTab_SectionName', children: sectionName(group[0].type) }), group.map((model) => {
                    let img;
                    try {
                        /**
                         * @todo import images from models-panel package
                         */
                        img = require(`assets/${model.image}.png`).default;
                    }
                    catch (_) { }
                    return ((0, jsx_runtime_1.jsx)(ItemCard_1.default, { onClick: handleClick(model), img: img, title: model.name, isSelected: false, disabled: isModelNotAvailable(model), access: model.access, accessLevel: bridge_schema_1.AccessLevel.Subscribed, "data-e2e": 'ModelsTab_ItemCard' }, model.index));
                })] }, type))) }));
}
exports.default = ModelsTab;
const sectionName = (type) => {
    switch (type) {
        case bridge_schema_1.ModelType.Male:
            return (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.male);
        case bridge_schema_1.ModelType.Female:
            return (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.female);
        default:
            return (0, i18n_1.Localized)(i18n_1.Strings.bodyRegionsPanel.detailed);
    }
};
const sortSections = ([typeA], [typeB]) => {
    // order should be: detailed, female, male
    switch (typeA) {
        case 'detailed':
            return -1;
        case 'male':
            return 1;
        case 'female':
            return typeB === 'detailed' ? 1 : -1;
        default:
            return 0;
    }
};
const SectionName = styled_components_1.default.div `
  padding: ${({ $isMobile }) => ($isMobile ? '4px 0px' : '6px 8px')};

  color: ${({ theme }) => theme.text};
  font-size: ${({ $isMobile }) => ($isMobile ? 16 : 12)}px;
  text-transform: uppercase;
`;
